import React, { useState, useEffect } from "react";



import { Link, useParams } from "react-router-dom"; // ✅ Import useParams
import db from "./Firebase";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import Moment from "moment";
import { extendMoment } from "moment-range";

function AllCourseData() {
    const { course_name } = useParams(); // ✅ Get course_name from URL
    const decodedCourseName = decodeURIComponent(course_name).trim().toLowerCase(); // ✅ Normalize name
    console.log(course_name)

    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [personalDetails, setPersonalDetails] = useState({});

    useEffect(() => {
        // const fetchData = async () => {
        //     try {
        //         const q = query(collection(db, "nv_enrolled_courses").orderBy("registered_date", "desc"));
        //         const snapshot = await getDocs(q);

        //         const courses = snapshot.docs.map((doc) => ({
        //             id: doc.id,
        //             data: doc.data(),
        //         }));

        //         // ✅ Ensure exact match
        //         const filteredCourses = courses.filter(({ data }) =>
        //             data.course_name.trim().toLowerCase() === decodedCourseName
        //         );

        //         setData(filteredCourses);
        //         fetchPersonalDetails(filteredCourses);
        //     } catch (error) {
        //         console.error("Error fetching data:", error);
        //     }
        // };

        const fetchData = async () => {
            try {
                const q = query(
                    collection(db, "nv_enrolled_courses"),
                    orderBy("registered_date", "desc") // ✅ Correct placement
                );
                const snapshot = await getDocs(q);

                const courses = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }));

                // ✅ Ensure exact match
                const filteredCourses = courses.filter(({ data }) =>
                    data.course_name.trim().toLowerCase() === decodedCourseName
                );

                setData(filteredCourses);
                fetchPersonalDetails(filteredCourses);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [decodedCourseName]);

    // **Fetch personal details for all phone numbers**
    const fetchPersonalDetails = async (courses) => {
        const phoneNumbers = [...new Set(courses.map(({ data }) => data.phone_no))];

        if (phoneNumbers.length === 0) return;

        let detailsMap = {};
        const batchSize = 10; // Firestore 'in' query limit

        for (let i = 0; i < phoneNumbers.length; i += batchSize) {
            const batch = phoneNumbers.slice(i, i + batchSize);
            const q = query(collection(db, "personal_details"), where("phone_no", "in", batch));
            const snapshot = await getDocs(q);

            snapshot.docs.forEach((doc) => {
                const d = doc.data();
                detailsMap[d.phone_no] = d.full_name || "N/A";
            });
        }

        setPersonalDetails(detailsMap);
    };

    return (
        <>
            <section>
                <div class="navi" style={{ backgroundColor: "#ec5d69" }}>
                    <input type="checkbox" id="nav-check" />
                    <div class="nav-header">
                        <div class="nav-title">
                            <Link to="/"> <img src="/bridal/youvati_white_logo.png" alt="" style={{ height: "22px", marginLeft: "1rem" }} /></Link>
                        </div>
                    </div>
                    <div class="nav-btn">
                        <label for="nav-check">
                            <span></span>
                            <span></span>
                            <span></span>
                        </label>
                    </div>

                </div>
            </section>
            <div className="p-3">
                <div className="card-header pb-0 px-3">
                    <h6 className="mb-2">Enrolled Course: {decodedCourseName || "All"}</h6> {/* ✅ Show selected course */}
                </div>

                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Sr. No</th>
                                <th>Course Name</th>
                                <th>Course Tag</th>
                                <th>Phone No</th>
                                <th>Name</th>
                                <th>Course Price</th>
                                <th>Glow Price</th>
                                <th>Paid Amount</th>
                                <th>Registered Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map(({ id, data }, index) => (
                                <tr key={id}>
                                    <td>{index + 1}</td>
                                    <td>{data.course_name}</td>
                                    <td>{data.course_tag}</td>
                                    <td>{data.phone_no}</td>
                                    <td>{personalDetails[data.phone_no] || "Loading..."}</td>
                                    <td>{data['course_price'].actual_price}</td>
                                    <td>{data['course_price'].membership_price}</td>
                                    <td>{data.amount}</td>
                                    <td>{moment(data.registered_date.toDate()).format("DD/MM/YY, h:mm a")}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default AllCourseData;



// import React, { useState, useEffect } from "react";



// import { Link } from "react-router-dom";
// import db from "./Firebase";
// import { collection, query, where, getDocs } from "firebase/firestore";
// import Moment from "moment";
// import { extendMoment } from "moment-range";

// function AllCourseData() {
//     const moment = extendMoment(Moment);
//     const [data, setData] = useState([]);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [personalDetails, setPersonalDetails] = useState({});

//     useEffect(() => {
//         // Fetch enrolled courses
//         const unsubscribe = db.collection("nv_enrolled_courses")
//             .orderBy("registered_date", "desc")
//             .onSnapshot((snapshot) => {
//                 const courses = snapshot.docs.map((doc) => ({
//                     id: doc.id,
//                     data: doc.data(),
//                 }));
//                 setData(courses);
//                 fetchPersonalDetails(courses); // Fetch names after courses are loaded
//             });

//         return () => unsubscribe();
//     }, []);

//     // **Fetch personal details for all phone numbers**
//     const fetchPersonalDetails = async (courses) => {
//         const phoneNumbers = [...new Set(courses.map(({ data }) => data.phone_no))];

//         if (phoneNumbers.length === 0) return; // No phone numbers to fetch

//         let detailsMap = {};
//         const batchSize = 10; // Firestore 'in' query limit

//         // **Fetch in batches of 10**
//         for (let i = 0; i < phoneNumbers.length; i += batchSize) {
//             const batch = phoneNumbers.slice(i, i + batchSize);
//             const q = query(collection(db, "personal_details"), where("phone_no", "in", batch));

//             const snapshot = await getDocs(q);
//             snapshot.docs.forEach((doc) => {
//                 const d = doc.data();
//                 detailsMap[d.phone_no] = d.full_name || "N/A"; // Default if missing
//             });
//         }

//         setPersonalDetails(detailsMap);
//     };

//     // **Filter Data Based on Search Query**
//     const filteredData = data.filter((record) =>
//         record.data.course_name.toLowerCase().includes(searchQuery.toLowerCase())
//     );

//     return (
//         <>

//             <div className="p-3">
//                 <div className="card-header pb-0 px-3">
//                     <h6 className="mb-2">Enrolled Course</h6>
//                 </div>

//                 <input
//                     type="text"
//                     className="form-control form-control-sm mb-2"
//                     placeholder="Search by Course Name"
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                 />

//                 <div className="table-responsive fix-width scroll-inner">
//                     <table className="table table-bordered table-hover">
//                         <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
//                             <tr>
//                                 <th>Sr. No</th>
//                                 <th>Course Name</th>
//                                 <th>Course Tag</th>
//                                 <th>Phone No</th>
//                                 <th>Name</th>
//                                 <th>Course Price</th>
//                                 <th>Glow Price</th>
//                                 <th>Paid Amount</th>
//                                 <th>Registered Date</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredData.map(({ id, data }, index) => (
//                                 <tr key={id}>
//                                     <td>{index + 1}</td>
//                                     <td>{data.course_name}</td>
//                                     <td>{data.course_tag}</td>
//                                     <td>{data.phone_no}</td>
//                                     <td>{personalDetails[data.phone_no] || "Loading..."}</td>
//                                     <td>{data['course_price'].actual_price}</td>
//                                     <td>{data['course_price'].membership_price}</td>
//                                     <td>{data.amount}</td>
//                                     <td>{moment(data.registered_date.toDate()).format("DD/MM/YY, h:mm a")}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default AllCourseData;

